import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-dropdown',
    templateUrl: './dropdown.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DropdownComponent implements OnInit {
  @Input() items?: any = [];
  @Input() placeholder: string = "";
  @Input() label: string = "";
  @Input() required: boolean = false;
  @Input() variant?: string;
  @Input() model?: any;
  @Input() disabled: boolean = false;
  @Input() value?: any;
  @Input() filter?: any;
  @Input() display?: string;
  @Input() multiple?: boolean = false;
  @Input() class?: string;
  @Output() onselect = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }
  onSelectAll(e: any) {
    this.onselect.emit(this.model);
  }
  onChange(event: any) {
    this.onselect.emit(event);
  }
}
